<template>
  <q-dialog
    ref="dialog"
  >
    <q-card>
      <q-card-section>
        {{ $t('programs.dataCollection.intervalTimer.iosAudioDialogQuestion') }}
      </q-card-section>
      <q-card-actions align="right">
        <q-btn
          v-close-popup
          flat
          color="secondary"
          :label="$t('programs.dataCollection.intervalTimer.iosAudioDialogCancel')"
        />
        <q-btn
          flat
          color="primary"
          :label="$t('programs.dataCollection.intervalTimer.iosAudioDialogSubmit')"
          @click="onSubmitForm"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapValues } from 'lodash';

export default {
  name: 'IntervalSoundConfirm',

  props: {
    intervalPrograms: {
      type: Object,
      required: true,
    },
  },

  emits: ['hide', 'ok'],

  methods: {
    show() {
      this.$refs.dialog.show();
    }, // show()

    hide() {
      this.$emit('hide');

      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    }, // hide()

    onSubmitForm() {
      const audioMap = this.createAudioMap();
      this.$emit('ok', audioMap);
      this.hide();
    }, // onSubmitForm()

    /**
     * We should create audio and play it once on user interaction to make interval sound work in iOS browser.
     * @see https://stackoverflow.com/a/31777081
     */
    createAudioMap() {
      return mapValues(this.intervalPrograms, () => this.createAndPlayAudio());
    }, // onOkAudio()

    /**
     * Creates a new audio object with muted sound and plays it once.
     *
     * @return {HTMLAudioElement}
     */
    createAndPlayAudio() {
      // eslint-disable-next-line max-len
      const silentAudio = 'data:audio/wav;base64,UklGRjIAAABXQVZFZm10IBIAAAABAAEAQB8AAEAfAAABAAgAAABmYWN0BAAAAAAAAABkYXRhAAAAAA==';
      const audio = new Audio(silentAudio);
      audio.play();

      return audio;
    }, // createAndPlayAudio()
  },
};
</script>

<style lang="scss" scoped>

</style>
